export default __webpack_public_path__ + "static/media/quarkus.59cdccd7.svg";